import React, { useState } from "react";
import { X } from "lucide-react";
import { toast } from "sonner";
import { Button, Card } from "./kit";
import api, { formatApiErrorDetail } from "../lib/api";

const EMPTY = { name: "", organization: "", email: "", participants: "", needs: "" };

export function ContactCustomModal({ open, onClose }) {
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  if (!open) return null;
  const set = (k) => (e) => setF((s) => ({ ...s, [k]: e.target.value }));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try { await api.post("/contact/custom", f); setDone(true); setF(EMPTY); }
    catch (err) { toast.error(formatApiErrorDetail(err.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const close = () => { setDone(false); onClose(); };
  return (
    <div data-testid="contact-custom-modal" onClick={close} style={{ position: "fixed", inset: 0, zIndex: 1000, background: "rgba(8,30,25,0.55)", display: "grid", placeItems: "center", padding: 16 }}>
      <Card padding="var(--space-8)" onClick={(e) => e.stopPropagation()} style={{ width: "100%", maxWidth: 520, maxHeight: "92vh", overflowY: "auto", position: "relative" }}>
        <button data-testid="contact-custom-close" onClick={close} aria-label="Close" style={{ position: "absolute", top: 16, right: 16, border: 0, background: "transparent", cursor: "pointer", color: "var(--text-faint)" }}><X size={20} /></button>
        {done ? (
          <div data-testid="contact-custom-success" style={{ textAlign: "center", padding: "var(--space-6) 0" }}>
            <h3 style={{ font: "var(--type-heading)", marginBottom: 8 }}>Thanks — we've got it.</h3>
            <p style={{ font: "var(--type-body-sm)", color: "var(--text-muted)", marginBottom: "var(--space-5)" }}>We'll be in touch within one business day to set up Catalyst Custom with you.</p>
            <Button onClick={close}>Close</Button>
          </div>
        ) : (
          <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: "var(--space-4)" }}>
            <div>
              <span className="buktu-eyebrow">Catalyst Custom</span>
              <h3 style={{ font: "var(--type-heading)", marginTop: 4 }}>Tell us about your program</h3>
            </div>
            <L label="Your name"><input required data-testid="contact-name" className="buktu-input" value={f.name} onChange={set("name")} /></L>
            <L label="Organization"><input required data-testid="contact-org" className="buktu-input" value={f.organization} onChange={set("organization")} /></L>
            <L label="Work email"><input required type="email" data-testid="contact-email" className="buktu-input" value={f.email} onChange={set("email")} /></L>
            <L label="Approximate number of participants"><input required data-testid="contact-participants" className="buktu-input" value={f.participants} onChange={set("participants")} placeholder="e.g. 3,000" /></L>
            <L label="What do you need to track?"><textarea required data-testid="contact-needs" className="buktu-input" rows={4} value={f.needs} onChange={set("needs")} placeholder="e.g. referrals, outcomes for our funder report…" style={{ resize: "vertical" }} /></L>
            <Button type="submit" data-testid="contact-submit" disabled={busy}>{busy ? "Sending…" : "Send"}</Button>
          </form>
        )}
      </Card>
    </div>
  );
}

function L({ label, children }) {
  return <label style={{ display: "flex", flexDirection: "column", gap: 6, font: "var(--type-label)", color: "var(--text-strong)" }}>{label}{children}</label>;
}
